export default __webpack_public_path__ + "static/media/pig-gold-medal.d72e291d.svg";